export default __webpack_public_path__ + "static/media/planet-saturn.801f886a.svg";